import { render, staticRenderFns } from "./FlussonicEmbedPlayer.vue?vue&type=template&id=2c681a88&scoped=true&"
import script from "./FlussonicEmbedPlayer.vue?vue&type=script&lang=js&"
export * from "./FlussonicEmbedPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FlussonicEmbedPlayer.vue?vue&type=style&index=0&id=2c681a88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c681a88",
  null
  
)

export default component.exports